import React, { useEffect } from 'react';
import {
	LaboratoryRequisition,
	useLaboratoryRequestsQuery,
	useWorkplaceLaboratoryRequisitionsQuery,
} from '../../../../graphql/graphql';
import SelectionListItem, {
	SelectionListItemScheme,
} from '../../../Base/Components/SelectionList/SelectionListItem';
import Text from '../../../../Components/Base/Text/Text';
import { useFlatDataList } from '../../../Base/Hooks/useFlatDataList';
import FlatList from '../../../Base/Components/FlatList';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import styles from './LaboratoryRequestList.module.scss';

interface Props {
	laboratoryId: string;
	onClick: (id: string) => void;
	buttonLabel?: string;
}

const wrapperId = 'laboratoryRequestListWrapper';

const LaboratoryRequestList: React.FC<Props> = ({
	laboratoryId,
	onClick,
	buttonLabel = 'component.laboratoryList.create',
}) => {
	const { flatData, pagination, getNextPage, appendData } =
		useFlatDataList<LaboratoryRequisition>();

	const { data, isLoading, refetch, isFetching } =
		useWorkplaceLaboratoryRequisitionsQuery({
			where: { laboratoryId },
			pagination,
		});

	useEffect(() => {
		refetch();
	}, []);

	const onItemClick = (item: SelectionListItemScheme) => {
		onClick(item.id);
	};

	useEffect(() => {
		const workplaceLaboratoryRequisitions =
			data?.workplaceLaboratoryRequisitions?.data ?? [];
		const laboratoryRequisitions = workplaceLaboratoryRequisitions
			.map(wlr => wlr.laboratoryRequisition)
			.filter(Boolean);

		appendData(laboratoryRequisitions);
	}, [data]);

	if (flatData.length < 1) {
		return <Text tx='component.laboratoryRequestList.noRequestsEnabled' />;
	}

	return (
		<ScrollContainer wrapperId={wrapperId} className={styles.wrapper}>
			<FlatList
				onRefresh={refetch}
				onLoadMore={getNextPage}
				data={flatData}
				isLoading={isLoading || isFetching}
				hasMoreData={
					data?.workplaceLaboratoryRequisitions?.meta?.hasNextPage || false
				}
				scrollableTargetId={wrapperId}
				renderItem={item => (
					<SelectionListItem
						item={item}
						onClick={onItemClick}
						buttonLabel={buttonLabel}
					/>
				)}
			/>
		</ScrollContainer>
	);
};

export default LaboratoryRequestList;
